import React, { Component } from 'react';
import PropTypes from 'proptypes';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import { Auth, API } from 'aws-amplify';
import { readableResponseMessage, phoneNumberValidator } from 'ux-helpers';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Countries, Nationalities } from './../../../helpers/CountriesAndNationalities';
import Modal from 'react-modal';
import ApplicationTermsAndConditionsModal from './ApplicationTermsAndConditionsModal';

export default class AdditionalInformation extends Component {
  state = {
    message: '',
  };

  componentDidMount() {
    const birthdayInput = document.getElementById('birthday');

    if (birthdayInput !== null) {
      birthdayInput.readOnly = true;
    }
  }

  openTermsAndConditionModal = modalName => {
    this.setState({
      activeModal: modalName,
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.additionalInformationForm.status === 'VALID') {
      this.setState({ loading: true });
      this.additionalInformationForm.handleSubmit();
      Auth.currentSession().then(user => {
        if (this.props.callbackFunction) {
          let updateUser = false;
          const userObject = this.props.user;
          const additionalInformation = this.additionalInformationForm.value;

          Object.keys(additionalInformation).forEach(function(key) {
            if (typeof additionalInformation[key] === 'string') {
              if (!userObject[key]) {
                updateUser = true;
              } else {
                if (userObject[key] !== additionalInformation[key]) {
                  updateUser = true;
                }
              }
            }
          });

          if (updateUser) {
            let updatedUserObject = { ...this.props.user, ...this.additionalInformationForm.value };
            this.props.setAppState(updatedUserObject);
          }
          this.props.callbackFunction(updateUser);
        } else {
          const options = {
            headers: {
              Authorization: user.idToken.jwtToken,
              Token: user.accessToken.jwtToken,
              'Content-Type': 'application/json',
            },
            body: this.additionalInformationForm.value,
          };
          options.body.userId = this.props.user.id;
          options.body.userName = user.idToken.payload.nickname;

          API.post('give-api', '/user/', options)
            .then(response => {
              this.setState(
                {
                  loading: false,
                  message: !this.props.callbackFunction ? response.Message : '',
                },
                () => {
                  this.props.setAppState({
                    ...this.props.user,
                    ...this.additionalInformationForm.value,
                  });
                  this.additionalInformationForm.handleSubmit();
                  this.props.deactiveActiveAccordion('additionalInformation-widget');
                }
              );
            })
            .catch(error => {
              this.setState({
                loading: false,
                message: readableResponseMessage(error),
              });
              this.additionalInformationForm.handleSubmit();
            });
        }
      });
    } else {
      this.additionalInformationForm.handleSubmit();
    }
  };

  additionalInformationForm = FormBuilder.group({
    birthdate: [
      this.props.user.birthdate
        ? moment(this.props.user.birthdate)
        : this.props.userProps.birthdate,
      Validators.required,
    ],
    nationality: [
      this.props.user.nationality ? this.props.user.nationality : this.props.userProps.country,
      Validators.required,
    ],
    citizenship: [
      this.props.user.citizenship ? this.props.user.citizenship : '',
      Validators.required,
    ],
    gender: [
      this.props.user.gender ? this.props.user.gender : this.props.userProps.gender,
      [Validators.required, Validators.maxLength(50)],
    ],
    shirtSize: [this.props.user.shirtSize ? this.props.user.shirtSize : '', Validators.required],
    chinesePassport: [
      this.props.user.chinesePassport === true || this.props.user.chinesePassport === false
        ? this.props.user.chinesePassport
        : '',
    ],
    emergencyContact: [
      this.props.user.emergencyContact ? this.props.user.emergencyContact : '',
      Validators.required,
    ],
    eCPhone: [
      this.props.user.eCPhone ? this.props.user.eCPhone : '',
      [Validators.required, phoneNumberValidator],
    ],
    eCEmail: [this.props.user.eCEmail ? this.props.user.eCEmail : '', [Validators.required]],
    eCRelationship: [
      this.props.user.eCRelationship ? this.props.user.eCRelationship : '',
      [Validators.required],
    ],
    medicalConditions: [
      this.props.user.medicalConditions ? this.props.user.medicalConditions : '',
      Validators.required,
    ],
    medications: [
      this.props.user.medications ? this.props.user.medications : '',
      Validators.required,
    ],
    genderIdentity: [
      this.props.user.genderIdentity ? this.props.user.genderIdentity : '',
      Validators.required,
    ],
    pronouns: [this.props.user.pronouns ? this.props.user.pronouns : '', Validators.required],
  });

  handleBirthdayChange = date => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    this.additionalInformationForm.controls.birthdate.setValue(formattedDate);
    this.setState({
      birthday: date,
    });
  };

  render() {
    const country = Countries.map((count, i) => (
      <option key={count} defaultValue={Countries[i]}>
        {Countries[i]}
      </option>
    ));

    const nationalities = Nationalities.map((count, i) => (
      <option key={count} defaultValue={Nationalities[i]}>
        {Nationalities[i]}
      </option>
    ));

    const birthdate = this.props.user.birthdate
      ? this.props.user.birthdate
      : this.props.userProps.birthdate;
    const nationality = this.props.user.nationality
      ? this.props.user.nationality
      : this.props.userProps.country;
    const citizenship = this.props.user.citizenship ? this.props.user.citizenship : '';
    const gender = this.props.user.gender ? this.props.user.gender : this.props.userProps.gender;
    const shirtSize = this.props.user.shirtSize
      ? this.props.user.shirtSize
      : this.props.userProps.shirtSize;
    let chinesePassport =
      this.props.user.chinesePassport != null
        ? this.props.user.chinesePassport
        : this.props.userProps.chinesePassport;
    const genderIdentity = this.props.user.genderIdentity ? this.props.user.genderIdentity : '';
    const pronouns = this.props.user.pronouns ? this.props.user.pronouns : '';

    if (!chinesePassport) {
      if (window.localStorage.getItem('additionalInformation')) {
        const additionalInformation = JSON.parse(
          window.localStorage.getItem('additionalInformation')
        );
        if (additionalInformation.chinesePassport) {
          chinesePassport = additionalInformation.chinesePassport;
        }
      }
    }

    const emergencyContact = this.props.user.emergencyContact
      ? this.props.user.emergencyContact
      : null;
    const eCEmail = this.props.user.eCEmail ? this.props.user.eCEmail : null;
    const eCPhone = this.props.user.eCPhone ? this.props.user.eCPhone : null;
    const eCRelationship = this.props.user.eCRelationship ? this.props.user.eCRelationship : null;

    let showChinesePassport = false;

    if (this.props.showChinesePassport) {
      showChinesePassport = true;
    } else {
      if (this.props.user.trips) {
        const trips = this.props.user.trips;
        Object.keys(trips).forEach(function(key) {
          if (trips[key].destination.includes('Nicaragua')) {
            showChinesePassport = true;
          }
        });
      }
    }

    let isProcessing = this.props.loading ? this.props.loading : this.state.loading;

    return (
      <div className="top-padding bottom-padding-large">
        {this.state.message ? (
          <p
            className={`center ${
              this.state.message === 'Your profile was successfully updated.' ? 'success' : 'error'
            }`}
          >
            {this.state.message}
          </p>
        ) : (
          ''
        )}
        <FieldGroup
          control={this.additionalInformationForm}
          render={({ value, submitted }) => (
            <form
              name="Additional Information"
              id="additional-information-form"
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              <div>
                {!birthdate ? (
                  <FieldControl
                    name="birthdate"
                    render={({ touched, hasError, pristine }) => (
                      <div className="inputContainer datepicker">
                        <DatePicker
                          className="form-control"
                          id="birthday"
                          selected={this.state.birthday}
                          onChange={this.handleBirthdayChange}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={moment()}
                          popperModifiers={{
                            flip: {
                              enabled: false,
                            },
                            preventOverflow: {
                              enabled: true,
                              escapeWithReference: false,
                            },
                          }}
                        />
                        <label
                          htmlFor="birthdate"
                          className={`label ${
                            pristine &&
                            !this.additionalInformationForm.controls.birthdate.value === ''
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          Birthday
                          <span className="error">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!gender ? (
                  <FieldControl
                    name="gender"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="gender"
                          className="custom-arrow form-control"
                          placeholder=""
                          {...handler()}
                        >
                          <option disabled value="">
                            {' '}
                            {' - Select - '}
                          </option>
                          <option value="Female">Female</option>
                          <option value="Male">Male</option>
                        </select>
                        <label htmlFor="gender" className={`label ${pristine ? '' : 'notEmpty'}`}>
                          Gender (on birth certificate or passport)
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!genderIdentity ? (
                  <FieldControl
                    name="genderIdentity"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="genderIdentity"
                          className="custom-arrow form-control"
                          placeholder=""
                          {...handler()}
                        >
                          <option disabled value="">
                            {' '}
                            {' - Select - '}
                          </option>
                          <option value="Female">Female</option>
                          <option value="Male">Male</option>
                          <option value="Transgender Female">Transgender Female</option>
                          <option value="Transgender Male">Transgender Male</option>
                          <option value="Agender">Agender</option>
                          <option value="Not Listed">Not Listed</option>
                        </select>
                        <label
                          htmlFor="genderIdentity"
                          className={`label ${pristine ? '' : 'notEmpty'}`}
                        >
                          Gender Identity (with which you identify)
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!pronouns ? (
                  <FieldControl
                    name="pronouns"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="pronouns"
                          className="custom-arrow form-control"
                          placeholder=""
                          {...handler()}
                        >
                          <option disabled value="">
                            {' '}
                            {' - Select - '}
                          </option>
                          <option value="She/Her">She/Her</option>
                          <option value="He/Him">He/Him</option>
                          <option value="She/They">She/They</option>
                          <option value="He/They">He/They</option>
                          <option value="They/Them">They/Them</option>
                          <option value="Not Listed">Not Listed</option>
                        </select>
                        <label htmlFor="pronouns" className={`label ${pristine ? '' : 'notEmpty'}`}>
                          Preferred Pronouns
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!nationality ? (
                  <FieldControl
                    name="nationality"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="nationality"
                          className="custom-arrow form-control"
                          placeholder="booleanStudentTrue"
                          {...handler()}
                        >
                          <option disabled value="">
                            {' '}
                            Nationality{' '}
                          </option>
                          {nationalities}
                        </select>
                        <label
                          htmlFor="nationality"
                          className={`label ${pristine ? '' : 'notEmpty'}`}
                        >
                          Your Nationality
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!citizenship ? (
                  <FieldControl
                    name="citizenship"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="citizenship"
                          className="custom-arrow form-control"
                          placeholder="booleanStudentTrue"
                          {...handler()}
                        >
                          <option disabled value="">
                            {' '}
                            Passport is/will be issued by{' '}
                          </option>
                          <option value="United States">United States</option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="Australia">Australia</option>
                          <option value="Canada">Canada</option>
                          {country}
                        </select>
                        <label
                          htmlFor="citizenship"
                          className={`label ${pristine ? '' : 'notEmpty'}`}
                        >
                          Passport Country you'll be traveling with
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!shirtSize ? (
                  <FieldControl
                    name="shirtSize"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <select
                          name="shirtSize"
                          className="custom-arrow form-control"
                          type="text"
                          {...handler()}
                        >
                          <option value="none">None</option>
                          <option value="XS">XS</option>
                          <option value="S">S</option>
                          <option value="M">M</option>
                          <option value="L">L</option>
                          <option value="XL">XL</option>
                          <option value="XXL">XXL</option>
                          <option value="XXXL">XXXL</option>
                        </select>
                        <label
                          htmlFor="shirtSize"
                          className={`label ${pristine ? '' : 'notEmpty'}`}
                        >
                          Your Shirt Size
                          <span className="error select-span-error-label-fix">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {chinesePassport == null && showChinesePassport ? (
                  <FieldControl
                    name="chinesePassport"
                    render={({ handler, touched, hasError }) => (
                      <div className="inputContainer">
                        <div className="form-control">
                          <label htmlFor="chinesePassport" className="label">
                            Traveling with a Chinese Passport?
                          </label>

                          <label htmlFor="chinesePassport">
                            <input
                              className="radio-button"
                              name="chinesePassport"
                              type="radio"
                              {...handler('radio', 'true')}
                            />
                            Yes
                          </label>
                          <label htmlFor="chinesePassport">
                            <input
                              className="radio-button"
                              name="chinesePassport"
                              type="radio"
                              {...handler('radio', 'false')}
                            />
                            No
                            <span className="error">
                              {(touched || submitted) && hasError('required') && ' - Required'}
                            </span>
                          </label>
                        </div>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!emergencyContact ? (
                  <FieldControl
                    name="emergencyContact"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input
                          id="emergencyContact"
                          className="form-control"
                          type="text"
                          {...handler()}
                        />
                        <label
                          htmlFor="emergencyContact"
                          className={`label ${
                            pristine &&
                            !this.additionalInformationForm.controls.emergencyContact.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          Emergency Contact Name
                          <span className="error">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!eCPhone ? (
                  <FieldControl
                    name="eCPhone"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input id="eCPhone" className="form-control" type="text" {...handler()} />
                        <label
                          htmlFor="eCPhone"
                          className={`label ${
                            pristine && !this.additionalInformationForm.controls.eCPhone.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          Emergency Contact Phone Number
                          <span className="error">
                            {((touched || submitted) && hasError('required') && ' - Required') ||
                              (touched && hasError('phoneNumber') && (
                                <span className="bubble-error-message">
                                  Format: XXX-XXX-XXXX, International X-XXX-XXX-XXXX
                                </span>
                              ))}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!eCEmail ? (
                  <FieldControl
                    name="eCEmail"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input className="form-control" type="email" {...handler()} />
                        <label
                          htmlFor="eCEmail"
                          className={`label ${
                            pristine && !this.additionalInformationForm.controls.eCEmail.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          Emergency Contact Email
                          <span className="error">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                            {hasError('maxLength') && ' - Exceeds Max Character Limit '}
                            {hasError('email') && ' - Please include @ with email address '}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                {!eCRelationship ? (
                  <FieldControl
                    name="eCRelationship"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input className="form-control" type="text" {...handler()} />
                        <label
                          htmlFor="eCRelationship"
                          className={`label ${
                            pristine &&
                            !this.additionalInformationForm.controls.eCRelationship.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          Emergency Contact Relationship
                          <span className="error">
                            {(touched || submitted) && hasError('required') && ' - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                ) : (
                  ''
                )}
                <div>
                  <p>
                    Please list any injuries and medical or mental health conditions and the dates
                    affected, including presently. Include any past medical history that may affect
                    your participation.
                  </p>
                  <FieldControl
                    name="medicalConditions"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <textarea className="form-control input-fix" type="text" {...handler()} />
                        <label
                          htmlFor="medicalConditions"
                          className={`label ${
                            pristine &&
                            !this.additionalInformationForm.controls.medicalConditions.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          <span className="error">
                            {(touched || submitted) &&
                              hasError('required') &&
                              'Medical Conditions - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
                <div>
                  <p>
                    Medications you currently take. You are responsible for providing and
                    self-administering any medications, prescription or over the counter, while on
                    the trip.
                  </p>

                  <FieldControl
                    name="medications"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <textarea className="form-control input-fix" type="text" {...handler()} />
                        <label
                          htmlFor="medications"
                          className={`label ${
                            pristine && !this.additionalInformationForm.controls.medications.value
                              ? ''
                              : 'notEmpty'
                          }`}
                        >
                          <span className="error">
                            {(touched || submitted) &&
                              hasError('required') &&
                              'Medications - Required'}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
                <div>
                  <p style={{ textAlign: 'center' }}>
                    Disclaimer: By submitting this form, you confirm that you will meet the minimum
                    age requirements of your selected trip by your departure date and agree that you
                    have read, understood, and agree to the{' '}
                    <button
                      type="button"
                      className="btn-plain-text"
                      onClick={() => this.openTermsAndConditionModal('termsAndCondition')}
                    >
                      Terms and Conditions
                    </button>{' '}
                  </p>
                </div>
                {this.props.submitMessage ? (
                  <h5 className="success center">{this.props.submitMessage}</h5>
                ) : (
                  ''
                )}
                <button
                  className={`${isProcessing ? 'btn-text-hide' : ''}`}
                  type="submit"
                  disabled={isProcessing}
                >
                  {this.props.submitButtonText}
                  <span className={`${isProcessing ? 'loader' : ''}`} />
                </button>
              </div>
            </form>
          )}
        />
        <Modal
          isOpen={this.state.activeModal === 'termsAndCondition'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ApplicationTermsAndConditionsModal closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

AdditionalInformation.propTypes = {
  setAppState: PropTypes.func,
  deactiveActiveAccordion: PropTypes.func,
  handleRouting: PropTypes.func,
  userProps: PropTypes.shape({
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
    citizenship: PropTypes.string,
    shirtSize: PropTypes.string,
    chinesePassport: PropTypes.string,
    emergencyContact: PropTypes.string,
    eCPhone: PropTypes.string,
    medicalConditions: PropTypes.string,
    medications: PropTypes.string,
  }),
  callbackFunction: PropTypes.func,
  submitButtonText: PropTypes.string,
  submitMessage: PropTypes.string,
  showChinesePassport: PropTypes.bool,
};

AdditionalInformation.defaultProps = {
  userProps: {},
  submitButtonText: 'Submit',
};
